import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { getPublicKey } from "./actions";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";

const loading = () => (
   <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

const LoginPage = React.lazy(() => import("./pages/login/login_page"));
const ForgetPasswordPage = React.lazy(() =>
   import("./pages/forgetpassword/forgetpassword_page")
);
const ResetPasswordPage = React.lazy(() =>
   import("./pages/resetpassword/resetpassword_page")
);
const CreatePasswordPage = React.lazy(() =>
   import("./pages/createpassword/createpassword_page")
);
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));
const Page404 = React.lazy(() => import("./views/Pages/Page404"));

class App extends Component {
   componentDidMount() {
      this.props.getPublicKey();
   }
   render() {
      return (
         <Router>
            <React.Suspense fallback={loading()}>
               <Switch>
                  <Route
                     exact
                     path="/login"
                     name="Login"
                     render={props => <LoginPage {...props} />}
                  />
                  <Route
                     path="/forgetpassword"
                     name="Forget Password"
                     render={props => <ForgetPasswordPage {...props} />}
                  />
                  <Route
                     path="/resetpassword/:tokenId"
                     render={props => <ResetPasswordPage {...props} />}
                  />
                  <Route
                     path="/createpassword/:uuid"
                     render={props => <CreatePasswordPage {...props} />}
                  />
                  <Route
                     path="/"
                     name="Dashboard"
                     render={props => <DefaultLayout {...props} />}
                  />
                  <Route
                     name="Page 404"
                     render={props => <Page404 {...props} />}
                  />
               </Switch>
            </React.Suspense>
         </Router>
      );
   }
}

const mapStateToProps = state => {
   return {
      publicKey: state.appConfig.publicKey
   };
};

export default connect(mapStateToProps, { getPublicKey })(App);
